/* LNGVTY landing page sections (lp-*). Shared behaviour:
   1. [data-slider]  swipe track + prev/next + segmented tracker + counter
   2. [data-lp-product]  size selector -> price, gallery filtering, sticky bar sync
   3. [data-lp-sticky]  sticky Buy now bar (shows after hero, hides near the buy button)
   Safe to load once per section: everything is guarded and re-runs on theme editor reloads. */
(function () {
  if (window.LPLanding) return;

  var pad = function (n) { return (n < 10 ? '0' : '') + n; };

  function initSlider(sl) {
    if (sl.dataset.lpReady) { sl.dispatchEvent(new Event('lp:rebuild')); return; }
    sl.dataset.lpReady = '1';
    var track = sl.querySelector('[data-slides]');
    if (!track) return;
    var bar = sl.querySelector('[data-bar]'), curEl = sl.querySelector('[data-cur]'),
        totEl = sl.querySelector('[data-tot]'), ctrl = sl.querySelector('[data-ctrl]'),
        slides = [], segs = [];

    function vis() { return [].filter.call(track.children, function (c) { return !c.hidden && c.nodeType === 1; }); }
    function gap() { return parseFloat(getComputedStyle(track).columnGap) || 0; }
    function go(i) {
      var n = slides.length; if (!n) return;
      i = (i + n) % n;
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft - (parseFloat(getComputedStyle(track).paddingLeft) || 0) });
    }
    function idx() {
      var n = slides.length; if (!n) return 0;
      var w = slides[0].getBoundingClientRect().width + gap();
      if (!w) return 0;
      var maxL = track.scrollWidth - track.clientWidth;
      if (maxL > 0 && track.scrollLeft >= maxL - 2) return n - 1;
      return Math.min(n - 1, Math.round(track.scrollLeft / w));
    }
    function paint() {
      var i = idx();
      segs.forEach(function (b, k) { b.setAttribute('aria-selected', k === i); });
      if (curEl) curEl.textContent = pad(i + 1);
    }
    function build() {
      slides = vis();
      if (totEl) totEl.textContent = pad(slides.length);
      if (bar) {
        bar.innerHTML = '';
        segs = slides.map(function (_, k) {
          var b = document.createElement('button');
          b.type = 'button'; b.setAttribute('role', 'tab');
          b.setAttribute('aria-label', 'Go to ' + (k + 1) + ' of ' + slides.length);
          b.addEventListener('click', function () { go(k); });
          bar.appendChild(b); return b;
        });
      }
      if (ctrl) ctrl.style.visibility = slides.length > 1 ? '' : 'hidden';
      track.scrollLeft = 0; paint();
    }
    sl.querySelectorAll('[data-prev]').forEach(function (b) { b.addEventListener('click', function () { go(idx() - 1); }); });
    sl.querySelectorAll('[data-next]').forEach(function (b) { b.addEventListener('click', function () { go(idx() + 1); }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(paint); }, { passive: true });
    sl.addEventListener('lp:rebuild', build);
    // details/accordion sliders have 0 width while closed: repaint when opened
    var det = sl.closest('details');
    if (det) det.addEventListener('toggle', function () { if (det.open) build(); });
    build();
  }

  function initProduct(root) {
    if (root.dataset.lpReady) return;
    root.dataset.lpReady = '1';
    // Note: GoKwik clones and replaces "Buy now" buttons, so buttons are always looked up fresh.
    var price = root.querySelector('[data-lp-price]'), qty = root.querySelector('[data-lp-qty]'),
        idInput = root.querySelector('[data-lp-variant-input]'), gallery = root.querySelector('[data-lp-gallery]');

    function showVariant(id) {
      if (!gallery) return;
      var any = false;
      gallery.querySelectorAll('[data-variants]').forEach(function (el) {
        var list = el.dataset.variants;
        var show = list === 'all' || (' ' + list + ' ').indexOf(' ' + id + ' ') > -1;
        el.hidden = !show; if (show) any = true;
      });
      if (!any) gallery.querySelectorAll('[data-variants]').forEach(function (el) { el.hidden = false; });
      // Lead with the selected size's own image(s), like the PDP does
      var own = [].filter.call(gallery.querySelectorAll('[data-variants]'), function (el) {
        return !el.hidden && el.dataset.variants !== 'all';
      });
      own.reverse().forEach(function (el) { el.parentNode.insertBefore(el, el.parentNode.firstElementChild); });
      gallery.dispatchEvent(new Event('lp:rebuild'));
    }

    function select(r) {
      if (idInput) idInput.value = r.value;
      var cmp = r.dataset.compare ? ' <s class="pinfo__compare">' + r.dataset.compare + '</s>' : '';
      if (price) price.innerHTML = r.dataset.price + cmp + (r.dataset.off ? ' <span class="pinfo__off">' + r.dataset.off + '</span>' : '');
      if (qty) qty.textContent = r.dataset.name;
      var available = r.dataset.available === 'true';
      var buy = root.querySelector('[data-lp-buy-btn]');
      if (buy) { buy.disabled = !available; buy.classList.toggle('is-soldout', !available); }
      var so = root.querySelector('[data-lp-soldout]'); if (so) so.hidden = available;
      showVariant(r.value);
      document.dispatchEvent(new CustomEvent('lp:variant-change', {
        detail: { id: r.value, name: r.dataset.name, price: r.dataset.price, compare: r.dataset.compare || '', available: available }
      }));
      try {
        var u = new URL(window.location.href); u.searchParams.set('variant', r.value);
        window.history.replaceState({}, '', u.toString());
      } catch (e) {}
    }

    root.querySelectorAll('[data-lp-variants] input').forEach(function (r) {
      r.addEventListener('change', function () { select(r); });
    });
    var checked = root.querySelector('[data-lp-variants] input:checked');
    if (checked) select(checked); else showVariant('');
  }

  function initSticky(bar) {
    if (bar.dataset.lpReady) return;
    bar.dataset.lpReady = '1';
    var meta = bar.querySelector('[data-lp-sticky-meta]');
    function btnEl() { return bar.querySelector('[data-lp-sticky-btn]'); }
    var pastHero = !document.querySelector('[data-lp-hero]'), buyVisible = false;
    function upd() {
      var on = pastHero && !buyVisible;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', !on);
      var b = btnEl(); if (b) b.tabIndex = on ? 0 : -1;
      // let floating widgets (WhatsApp button) move up while the bar is showing
      var de = document.documentElement;
      de.style.setProperty('--lp-sticky-h', bar.offsetHeight + 'px');
      de.classList.toggle('lp-sticky-on', on);
    }
    var hero = document.querySelector('[data-lp-hero]'), buyBox = document.querySelector('[data-lp-buybox], .lp-serums-sx7mq');
    if ('IntersectionObserver' in window) {
      if (hero) new IntersectionObserver(function (e) { pastHero = !e[0].isIntersecting && e[0].boundingClientRect.top < 0; upd(); }).observe(hero);
      if (buyBox) new IntersectionObserver(function (e) { buyVisible = e[0].isIntersecting; upd(); }).observe(buyBox);
    } else { pastHero = true; }
    document.addEventListener('lp:variant-change', function (e) {
      if (meta) meta.innerHTML = e.detail.name + ' &middot; ' + e.detail.price + (e.detail.compare ? ' <s class="pinfo__compare">' + e.detail.compare + '</s>' : '');
      var b = btnEl(); if (b) b.disabled = !e.detail.available;
    });
    // No product form on the page (section used alone): fall back to scrolling to the product section
    var btn = btnEl();
    if (btn && btn.tagName === 'BUTTON' && !document.getElementById(btn.getAttribute('form'))) {
      btn.addEventListener('click', function (ev) {
        ev.preventDefault();
        var t = document.querySelector('[data-lp-product], #lp-product'); if (t) t.scrollIntoView({ behavior: 'smooth' });
      });
    }
    window.addEventListener('resize', upd, { passive: true });
    upd();
  }

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-lp-product]').forEach(initProduct);
    scope.querySelectorAll('[data-slider]').forEach(initSlider);
    document.querySelectorAll('[data-lp-sticky]').forEach(initSticky);
  }

  window.LPLanding = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
